module.exports = __webpack_public_path__ + "b0b6c2fb5337236fedb09a2b325f952f.jpg";